import { render, staticRenderFns } from "./DoNotLend.vue?vue&type=template&id=91a70f26&"
import script from "./DoNotLend.vue?vue&type=script&lang=js&"
export * from "./DoNotLend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports